<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import floppyDisk from "../../../static/assets/images/floppy-disk.svg";
export default {
  components: {
    FontAwesomeIcon,
  },
  name: "FloatingButton",
  data() {
    return {
      floppyDisk,
    };
  },
  computed: {
    coloursOptions() {
      return this.$store.getters[`${this.currentType}/coloursOptions`];
    },
    activeColour() {
      return this.coloursOptions && this.currentActivity.colour
        ? this.coloursOptions.find(
            (option) => option.id == this.currentActivity.colour
          )
        : null;
    },
    currentActivity() {
      return this.$store.getters[`${this.currentType}/currentActivity`];
    },
    currentType() {
      const url = this.$route.path.split("/")[1];
      if (this.$route) {
        if (url == "update-warmup" || this.$route.path == "/create-warmup") {
          return "warmups";
        } else if (
          url == "update-stretch-flow" ||
          this.$route.path == "/create-stretch-flow"
        ) {
          return "stretchflows";
        } else if (
          url == "update-workout" ||
          this.$route.path == "/create-workout"
        ) {
          return "workouts";
        }
      }
      return "commons";
    },
  },
  methods: {
    updateActivity() {
      this.$store
        .dispatch(`${this.currentType}/updateActivity`, this.currentActivity.id)
        .then(
          (res) => {
            // this.makeToast("success", "Success", `Succesfully saved.`);
            this.$store.commit(`commons/setSavingForm`, "Saved");
          },
          (error) => {
            console.log(
              error
            );
          }
        );
    },
    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
  },
};
</script>

<style lang="scss">
.floating-btn {
  right: 4vw;
  bottom: 5vh;
  border: 0;
  background: transparent;
  margin: 0;
  padding: 0;

  z-index: 999;
  position: fixed;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  span {
    box-shadow: 0 10px 10px rgb(0 0 0 / 20%), 0 4px 4px rgb(0 0 0 / 15%);
    background: #347b7d;
    color: #fff;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    display: flex;
    text-align: center;
    img {
      width: 30px;
    }
  }

  &:disabled {
    cursor: auto;
    span {
      background: #e3e3e3 !important;
      color: #b0b0b0;
    }
  }
}
</style>

<template>
  <div class="floating-btn btn no-outline" @click="updateActivity">
    <span class="d-flex justify-content-center align-items-center">
      <img :src="floppyDisk" />
    </span>
  </div>
</template>